import { indexItems } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            主题合集
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            八大热门专题，总有一个是你想吃的瓜
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className={`${item.icon} text-sm`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}